/**
 * 通用类
 */
export namespace GeneralKind {
    
    /** 通用数值 */  
    export enum GeneralValue {
        /** 最大等级 */
        MAX_LEVEL = 18,
        /** 每天赠送漕运单数量 */
        EVENT_DAY_WATER_TRANSPORT = 2,
        /** 固定时间事件第一次的开始时间 小时*/
        FIXED_EVENT_START_TIME = 2,
        /** 跳动的游戏时间 单位分钟 */
        GAME_TIME_JUMP = 6,
        /** 考试成功增加经验 */
        EXAM_SUCCESS_ADD_EXP = 100,
        /** 穿越版本号 */
        CUR_THRUN_VERSION = 0,
    }

    /** 功能类型 */
    export enum ValueChangeType {
        /** 声望变化 */
        PRESTIGE = 'prestige',
        /** 金币变化 */
        GOLD = 'gold',
        /** 获得物品并展示获得物品界面 */
        GOODS_GET = 'goods_get',
        /** 隐式获得物品不展示 */
        GOODS_GET_HIDE = 'goods_get_hide',
        /** 扣除物品 */
        GOODS_DEDUCT = 'goods_deduct',
        /** 什么也不会发生 */
        NONE = 'none',
        /** 下一个id */
        NEXT_ID = 'nextId',
        /** 下一个固定天数事件 */
        NEXT_FIXED_DAY_EVENT = 'next_fixed_day_event',
        /** 有无官阶判断 */
        IS_OFFICIAL = 'is_official',
        /** 是否达到官阶条件 */
        REACH_LEVEL = 'reach_level',
        /** 退出界面 */
        EXIT_LAYER = 'exitLayer',
        /** 保存数据并退出 */
        SAVE_EXIT = 'save_exit',
        /** 缴税事件 */
        RATE_PAYMENT = 'rate_payment',
        /** 特殊还款事件 */
        SPECAIL_REPAYMENT = 'specail_repayment',
        /** 飞鸽事件 */
        FLUEGER = 'flueger',
        /** 打开背包 */
        OPEN_PACKSACK = 'open_packsack',
        /** 打开背包 */
        SHOW_PACKSACK = 'show_packsack',
        /**升级官阶 */
        UPGRADE_OFFICIALLV = 'upgrade_officiallv',
        /**引导进入功能模块 */
        GUIDE_ENTER_LAYER = 'guide_enter_layer',
        /** 压入死牢 */
        PUSH_DIE_JAIL = 'push_die_jail',
        /** 发配边疆 */
        BANISH_FRONTIER = 'banish_frontier',
        /** 是否有物品，有则扣除1个，并显示事件按钮 */
        OWN_DEDUCT_GOODS = 'own_deduct_goods',
        /** 学习无相神功 */
        STUDY_GONGFU_1 = 'study_gongfu_1',
        /** 是否学会无相神功并显示 */
        IS_OWN_GONGFU_1 = 'is_own_gongfu_1',
        /** 是否拥有证物 */
        OWN_EXHIBIT = 'own_exhibit',
        /** 购买府邸完成 */
        SUCCESS_BUY_MANSION = 'success_buy_mansion',
        /** 打开比武招亲第二关 */
        OPEN_MATCH_MIAI_SECOND_LEVEL = 'open_match_miai_second_level',
        /** 打开主事件id */
        OPEN_MAIN_EVENT = 'open_main_event',
        /** 延迟调用main_event表格事件id */
        DELAY_OPEN_MAIN_EVENT = 'delay_open_main_event',
        /** 完成比武招亲第二关 */
        FINISH_MATCH_MIAI_SECOND_LEVEL = 'finish_match_miai_second_level',
        /** 重置比武招亲关卡数据 */
        RESET_MATCH_MIAI_LEVEL = 'reset_match_miai_level',
        /** 获得比武招亲丘比特之箭道具 */
        GET_CUPID_ARROW = 'get_cupid_arrow',
        /** 比武招亲彩礼 */
        MATCH_MIAI_BRIDE_PRICE = 'match_miai_bride_price',
        /** 中断飞鸽 */
        BREAK_WECHAT = 'break_wechat',
        /** 打开言出法随合成界面 */
        OPEN_SUPER_POWER_COMPOUND = 'open_super_power_compound',
        /** 触发任务 */
        TRIGGER_TASK = 'trigger_task',
        /** 完成任务 */
        FINISH_TASK = 'finish_task',
        /** 娶老婆 */
        TAKE_TO_WIFE = 'take_to_wife',
        /** 扣钱，最多到0 */
        GOLD_DEDUCT_SPECIAL = 'gold_deduct_special',
        /** 观看广告 */
        VIDEO_LOOK = 'video_look',
        /**打开选妃 */
        OPEN_SELECT_CONCUBINE = 'open_select_concubine',
        /**打乱选妃顺序 */
        SELECT_CONCUBINE_RANDSORT = 'select_concubine_randsort',
        /**退出选妃 */
        CLOSE_CONCUBINE = 'close_concubine',
        /** 关闭选妃揭盖头 */
        CLOSE_SELECT_CONCUBINE = 'close_select_concubine',
    }

    /** 延迟事件条件类型 */
    export enum DelayEventCondType {
        /** 是否完成飞鸽记录点 */
        CON_TYPE1 = 'conType1',
    }

    /** 刮刮乐 */
    export enum ScratchTicketValue {
        /** 单点圆大小 */
        SINGLE_TOUCH_CIRCLE = 20,
        /**  */
        EVERY_CIRCLE_ADJUST = 6,
        /** 生肖数量 */
        ANIMAL_COUNT = 12,
        /** 特殊生肖数字 */
        SPECIAL_ANIMAL_NUM = 13,
        /** 特殊生肖几率 */
        SPECIAL_ANIMAL_PROBABILITY = 0,
       
    }

    /** 道具id */
    export enum PropId {
        /** 漕运单 */
        WATER_TRANSPORT_CARD_ID = 29001,
        /** 盲盒物品id */
        ANIMAL_GOODS_ID = 30001,
        /** 钦天鉴 */
        ASTRONOMER_MIRROR_ID = 30002,
        /** 丹书铁券 */
        THE_MEDALLION_ID = 30003,
        /** 神农鼎 */
        SHEN_NONG_DING = 50012,
        /** 丘比特神箭 */
        CUPID_ARROW_ID = 50011,
        /** 紫色女娲石 */
        PURPLE_NVWA_STORE = 50005,
        /** 广告卡 */
        AD_CARD = 50046,
        
    }

    /** 状态 */
    export enum EnableState {
        /** 无效 */
        DISABLED = 0,
        /** 可用 */
        ENABLED,
    }

    /** 触发飞鸽 */
    export enum TriggerChatId {
        /** 第一次进入当铺 */
        FIRST_ENTER_PAWN = '9',
        /** 第一次工作 */
        FIRST_JOB = '11',
        /** 第一次购买石头 */
        FIRST_BUY_STORE = '12',
        /** 第一次购买城池 */
        FIRST_BUY_CITY = '14',
    }

    /** 五彩果 */
    export const OrchrdCollect = [50049, 50050, 50051, 50052];
}